export default __webpack_public_path__ + "static/media/happy.2abe7ca8.svg";